import {stage} from './stage';

const rum = {
    prd: {
        isEnabled: true,
        applicationId: '8aed2796-7a11-4667-88eb-db9138a8795f',
        applicationVersion: '1.0.0',
        applicationRegion: 'us-west-2',
        config: {
            sessionSampleRate: 1,
            identityPoolId: 'us-west-2:68a710d8-3068-4fbb-b147-af24c30e2a8d',
            telemetries: ['errors', 'performance', 'http'],
            allowCookies: true,
            enableXRay: true,
        },
    },
    test: {
        isEnabled: false,
        applicationId: '0fd8ac4f-930f-48b2-81e3-d607a899088e',
        applicationVersion: '1.0.0',
        applicationRegion: 'us-west-2',
        config: {
            sessionSampleRate: 1,
            identityPoolId: 'us-west-2:b24d69a8-ea6d-44ac-a2f3-7862de54d31a',
            telemetries: ['errors', 'performance', 'http'],
            allowCookies: true,
            enableXRay: true,
        },
    },
    dev: {
        isEnabled: true,
        applicationId: '2ca946e4-6df2-4367-9524-eb0a4c83a453',
        applicationVersion: '1.0.0',
        applicationRegion: 'us-west-2',
        config: {
            sessionSampleRate: 1,
            identityPoolId: 'us-west-2:1760251d-ab6e-48d0-9a8f-388aac6bcf88',
            telemetries: ['errors', 'performance', 'http'],
            allowCookies: true,
            enableXRay: true,
        },
    },
    ide: {
        isEnabled: true,
        applicationId: '2ca946e4-6df2-4367-9524-eb0a4c83a453',
        applicationVersion: '1.0.0',
        applicationRegion: 'us-west-2',
        config: {
            sessionSampleRate: 1,
            identityPoolId: 'us-west-2:1760251d-ab6e-48d0-9a8f-388aac6bcf88',
            telemetries: ['errors', 'performance', 'http'],
            allowCookies: true,
            enableXRay: true,
        },
    },
};

const RUM = {
    isEnabled: rum[stage].isEnabled,
    applicationId: rum[stage].applicationId,
    applicationVersion: rum[stage].applicationVersion,
    applicationRegion: rum[stage].applicationRegion,
    config: rum[stage].config,
};

export default RUM;
